import { TextField } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import {
  CURTAIN,
  DOOR_LOCK,
  LIGHT,
  SCENE,
  THERMO,
  thermostatAttributes,
  thermostatCustomAttribute,
  vendorAttributeList,
} from '../../constants/VendorConst';
import './VendorCard.scss';

const VendorCard = (props) => {
  const { type, vendorDetails, onChangeUpdateAttr, onChangeThermostatAttr, vendorAttr } = props;
  const [expanded, setExpanded] = useState(false);
  const [attributes, setAttributes] = useState({});
  const [customAttributes, setCustomAttributes] = useState({});

  useEffect(() => {
    const objArr = thermostatCustomAttribute?.reduce(
      (object, key) => ({ ...object, [key]: getPreDefinedValue(key, 'custom') ?? '' }),
      {},
    );
    setCustomAttributes(objArr);
  }, []);

  useEffect(() => {
    const objArr = vendorDetails?.enabledAttributes?.reduce(
      (object, key) => ({ ...object, [key]: getPreDefinedValue(key, 'default') ?? '' }),
      {},
    );
    setAttributes(objArr);
  }, [vendorDetails]);

  const getPreDefinedValue = (key, attrType) => {
    switch (type) {
      case LIGHT:
        return (
          vendorAttr && (vendorAttr.lights[attrType].find((item) => item.key === key)?.value ?? '')
        );
      case THERMO:
        return (
          vendorAttr &&
          (vendorAttr.thermostats[attrType].find((item) => item.key === key)?.value ?? '')
        );
      case CURTAIN:
        return (
          vendorAttr &&
          (vendorAttr.curtains[attrType].find((item) => item.key === key)?.value ?? '')
        );
      case SCENE:
        return (
          vendorAttr && (vendorAttr.scenes[attrType].find((item) => item.key === key)?.value ?? '')
        );
      case DOOR_LOCK:
        return (
          vendorAttr &&
          (vendorAttr.doorLock[attrType].find((item) => item.key === key)?.value ?? '')
        );
      default:
        return '';
    }
  };

  const handleOnChangeDefault = (e, key) => {
    const userInput = e?.target?.value;
    const attributeCopy = { ...attributes };
    attributeCopy[key] = userInput;
    setAttributes(attributeCopy);
    updateVendorKeyValueDefault(attributeCopy);
  };

  const updateVendorKeyValueDefault = (updatedArr) => {
    const formattedAttr = [];
    for (const [key, value] of Object.entries(updatedArr)) {
      const newObj = {
        key: key,
        value: value,
      };
      formattedAttr.push(newObj);
    }
    onChangeUpdateAttr(formattedAttr);
  };

  const handleOnChangeCustom = (e, key) => {
    const userInput = e?.target?.value;
    const customAttributesCopy = { ...customAttributes };
    customAttributesCopy[key] = userInput;
    setCustomAttributes(customAttributesCopy);
    updateVendorKeyValueCustom(customAttributesCopy);
  };

  const updateVendorKeyValueCustom = (updatedArr) => {
    const formattedAttr = [];
    for (const [key, value] of Object.entries(updatedArr)) {
      const newObj = {
        key: key,
        value: value,
      };
      formattedAttr.push(newObj);
    }
    onChangeThermostatAttr(formattedAttr);
  };

  const convertEnumToString = (value) => {
    return vendorAttributeList.find((item) => item.value === value)?.name;
  };

  return (
    <div className='d-flex vendor-card p-3 justify-content-between'>
      <div className='row w-100'>
        {vendorDetails &&
          vendorDetails?.enabledAttributes.map((item, i) => (
            <div className={`col-md-6 mb-3 ${i > 1 && !expanded ? 'hidden' : ''} `} key={i}>
              <TextField
                label={convertEnumToString(item)}
                id={`vendorAttribute_${item}`}
                className='w-100'
                onChange={(e) => {
                  handleOnChangeDefault(e, item);
                }}
                value={attributes[item]}
              />
            </div>
          ))}
        {type === THERMO &&
          thermostatAttributes.map((item, i) => (
            <div className={`col-md-6 mb-3 ${!expanded && 'hidden'} `} key={i}>
              <TextField
                label={item.name}
                id={`vendorAttribute_${item}`}
                className='w-100'
                onChange={(e) => {
                  handleOnChangeCustom(e, item.value);
                }}
                value={customAttributes[item]}
              />
            </div>
          ))}
      </div>
      <div className='vendor-card-arrow'>
        {expanded ? (
          <ExpandLess fontSize='large' onClick={() => setExpanded(false)} />
        ) : (
          <ExpandMore fontSize='large' onClick={() => setExpanded(true)} />
        )}
      </div>
    </div>
  );
};

export default VendorCard;
